(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["off-pitch-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var link = event.target.closest('[data-op-cookie-settings]');
  if (link && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    event.preventDefault();
    Promise.resolve(window.privacyBanner.showPreferences()).catch(function() { window.location.href = link.href; });
  }
});

  } catch(e) { console.error(e); }
})();
})();
